/**
 * The built-in sample vehicle: the product plan's own reference example (PP §10).
 *
 * "At valuation year 2026, model year 2025, Markazia Normal, 21,200 JOD reference, 42,000 km and one
 * owner: age 2, age depreciation 25%, mileage penalty 0.5%, corrected base 15,820.5 JOD."
 *
 * The Equations page prices this vehicle live while an administrator edits the formulas, which is why
 * it lives in the engine rather than in the web app: the sample, the specs that pin those figures and
 * the seed policy are then guaranteed to be talking about the same vehicle. Phase 2 lets the page pick
 * a real template's published values instead.
 */
import { DEPRECIATION_PRESETS, paramsForPreset } from '../templates/param-catalog.js';
export const SAMPLE_PRESET_KEY = 'MARKAZIA_NORMAL';
export const SAMPLE_DEFAULTS = {
    valuationYear: 2026,
    modelYear: 2025,
    referencePrice: 21_200,
    odometerKm: 42_000,
    ownerCount: 1,
};
/**
 * The condition is the "all excellent, grade 7, no damage" vehicle of the reference example, and the
 * facelift and customs questions are answered No — the example has no deduction for either. Nothing is
 * left `UNKNOWN`, so the sample always prices and the preview never reads as incomplete.
 */
export const referenceSampleBundle = (overrides = {}) => {
    const preset = DEPRECIATION_PRESETS.find((entry) => entry.key === SAMPLE_PRESET_KEY);
    const valuationYear = overrides.valuationYear ?? SAMPLE_DEFAULTS.valuationYear;
    return {
        owner: 'ESTIMATE',
        valuationDate: `${valuationYear}-09-10`,
        facts: {
            modelYear: overrides.modelYear ?? SAMPLE_DEFAULTS.modelYear,
            referencePrice: SAMPLE_DEFAULTS.referencePrice,
            odometerKm: overrides.odometerKm ?? SAMPLE_DEFAULTS.odometerKm,
            ownerCount: overrides.ownerCount ?? SAMPLE_DEFAULTS.ownerCount,
            fuel: 'HYBRID',
            // Comfortably beyond the 40-day threshold, so the licensing, general and registration fees are
            // zero on the sample and an admin can see the conditional working.
            registrationExpiry: `${valuationYear + 1}-03-01`,
            faceliftApplies: false,
            customsApplies: false,
            hasSpareKey: false,
            hasOwnersManual: false,
            hasToolKit: false,
            hasSpareTire: false,
            acquisitionType: 'DIRECT',
            profitMode: 'FIXED',
            taxTrafficEstimate: 0,
            otherDirectCostEstimate: 0,
            ctaOffer: null,
        },
        inspection: {
            grade7: 'G7',
            interior: 'EXCELLENT',
            engine: 'EXCELLENT',
            hybrid: 'EXCELLENT',
            tires: 'EXCELLENT',
            damageGroup1Index: 0,
            damageGroup2Index: 0,
        },
        template: {
            params: paramsForPreset(SAMPLE_PRESET_KEY),
            damageGroup1: preset.damageGroup1,
            damageGroup2: preset.damageGroup2,
        },
        overrides: {},
        costItems: [],
        tradeIn: null,
    };
};
//# sourceMappingURL=sample-bundle.js.map